// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd31844c","239":"6095b6d3","453":"a9e7d93c","732":"5e54964d"}[chunkId] + ".chunk.js";
};